import TreeView, { TreeViewNode } from "@hl/base-components/lib/TreeView";
import {
  Image as ImageIcon,
  FileCode as FileIcon,
  Folder as FolderIcon,
} from "@hl/base-components/lib/assets/icons.generated";
import { UTILITY_COLOR } from "@hl/base-components/lib/theme/colors";
import { Card } from "@mantine/core";

const getFileIcon = (fileName: string) => {
  if (fileName.endsWith("/")) {
    return <FolderIcon />;
  }
  if (/\.(png|jpg|jpeg|gif)$/.test(fileName)) {
    return <ImageIcon />;
  }
  return <FileIcon />;
};

interface FileNode {
  name: string;
  type: "file" | "folder";
  children?: FileNode[];
}

function buildFileTree(files: string[]): FileNode[] {
  const fileTree: FileNode[] = [];

  const processFile = (filePath: string) => {
    const isFolderPath = filePath.endsWith("/");
    const parts = filePath.split("/");
    let currentNode: FileNode[] = fileTree;

    for (let i = 0; i < parts.length; i++) {
      const isFolder = isFolderPath || i < parts.length - 1;

      const name = parts[i] + (isFolder ? "/" : "");
      if (name === "/") {
        continue;
      }

      let foundNode: FileNode | undefined = currentNode.find(
        (node) => node.name === name
      );

      if (!foundNode) {
        foundNode = {
          name,
          type: isFolder ? "folder" : "file",
        };
        currentNode.push(foundNode);
      }

      if (isFolder) {
        if (!foundNode.children) {
          foundNode.children = [];
        }
        currentNode = foundNode.children;
      }
    }
  };

  for (const file of files) {
    processFile(file);
  }

  return fileTree;
}

const toRenderNode = (fileNode: FileNode, index: number): TreeViewNode => ({
  key: index.toString(),
  label: fileNode.name,
  icon: getFileIcon(fileNode.name),
  children: fileNode.children?.map(toRenderNode),
});

export const PackageTreePreview = ({ files }: { files: string[] }) => (
  <Card py={0} bg={UTILITY_COLOR.TABLE_ROW_BACKGROUND}>
    <TreeView root treeData={buildFileTree(files).map(toRenderNode)} />
  </Card>
);
